import Hero from "./hero";
import AboutUs from "./aboutUs";
export default function Home() {
  return (
    <div>
      <Hero />
      <AboutUs />
    </div>
  );
}
